import React, { useState, useContext, useEffect, useRef } from 'react'
import { NavLink, useLocation, useHistory } from 'react-router-dom'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import CustomDialog from '../../../components/organisms/Dialog'
import {
    Badge,
    Button,
    Divider,
    ListItem,
    Menu,
    MenuItem,
    SwipeableDrawer,
} from '@material-ui/core'
import AuthContext from '../../../../product/context/auth/authContext'
import CommonContext from '../../../../product/context/common/commonContext'
import UserContext from '../../../../product/context/user/userContext'
import AlertContext from '../../../../product/context/alert/alertContext'
import NorthCapitalContext from '../../../../product/context/payment/northcapital/northcapitalContext'
import { handleRedirectInternal } from '../../../../product/common/components'
import './Header.css'
import ProductContext from '../../../../product/context/product/productContext'
import BidHistory from '../../../components/organisms/BidHistory'
import TTWBidHistory from '../../../components/organisms/TTWBidHistory'
import KYCUpdate from '../../../components/organisms/KYCUpdate'
import BuynowContext from '../../../../product/context/buynow/buynowContext'
import Loaders from '../Loaders'
import MenuList from '@material-ui/core/MenuList'
import { makeStyles } from '@material-ui/core/styles'
import Popover from '@material-ui/core/Popover'
import { IconButton } from '@material-ui/core'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { LOGO, LOGO_WHITE } from '../../../../Utils'
import SideNavBar from '../SideNavBar'
import FreeShares from '../../organisms/FreeShares'
import CustomCommonContext from '../../../../custom/context/common/commonContext'
import FormDialog from '../../../../product/components/organisms/Dialog'
import classNames from 'classnames'
import { capitalizeFirstLetter } from '../../../common/components'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'

const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: 9999,
    },
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
}))

const Header = () => {
    const classes = useStyles()
    const [aucopen, setAucOpen] = React.useState(false)
    const [menu, setMenu] = React.useState('auction')
    const [userType, setUserType] = useState(0)
    const anchorRef = React.useRef(null)
    const [showNonResident, setShowNonResident] = useState(false)
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent)
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const commonContext = useContext(CommonContext)
    const productContext = useContext(ProductContext)
    const [documentUploaded, setDocumentUploaded] = useState(false)
    const [accountPopup, setAccountPopup] = useState(false)
    const [kycAdminReview, setKycAdminReview] = useState(false)
    const [verify, setVerify] = useState(false)
    const [dismissVerifyStartBanner, setDismissVerifyStartBanner] = useState(false)
    const [bank, setBank] = useState(false)
    const [recentTransactions, setRecentTransactions] = useState([])
    const [card, setCard] = useState(false)
    const buynowContext = useContext(BuynowContext)

    const {
        updateProfile,
        responseStatus: responseStatusUser,
        sendEmailVerifyLink,
        getCompanyOwners,
        company_owner_data,
    } = useContext(UserContext)
    const customCommonContext = useContext(CustomCommonContext)
    const { setAlert } = alertContext
    const {
        user,
        isAuthenticated,
        loadPendingCount,
        loadPendingTempCount,
        isAdmin,
        cartTempCount,
        cartCount,
        logout,
    } = authContext
    const {
        getOffers,
        freeOffers,
        clearOffers,
        toggleDialogCanada,
        setToggleDialogCanada,
        canadaUserErrorMessage,
    } = customCommonContext
    const [freePopup, setFreePopup] = useState(false)
    const [userVerify, setUserVerify] = useState('')
    const [freeData, setFreeData] = useState([])
    const [welcomePopup, setWelcomePopup] = useState(false)

    const [restrictPopup, setRestrictPopup] = useState(false)

    const [state, setState] = useState({
        right: false,
        top: false,
    })
    const history = useHistory()
    const [anchormenu, setanchormenu] = useState(null)
    const [anchorcart, setanchorcart] = useState(null)
    const [initLoad, setInitLoad] = useState(false)

    const { getAllSearchProducts, clearResponse } = productContext

    const { getAllCartProducts, search_allproducts } = buynowContext
    const {
        northCapitalUser,
        getUserDetails,
        north_capital_bank_details,
        getExternalAccount,
        north_capital_card_details,
        addCampaignContact,
        getCreditCard,
        getLinkedCreditCard,
    } = useContext(NorthCapitalContext)

    const { searchValue, setSearchValue, isLoading } = commonContext
    const [kycProcessed, setKycProcessed] = useState(false)
    const [searchText, setSearchText] = useState('')
    let [cartProducts, setCartProducts] = useState([])
    const [showRecord, setShowRecord] = useState(false)
    const [hideRecord, setHideRecord] = useState(false)
    const [search, setSearch] = useState({})
    const [searchBox, setSearchBox] = useState(false)
    const [params, setParams] = useState(null)
    const location = useLocation()
    const [circle, setCircle] = useState({
        emailVerified: false,
        setupPaymentMethod: false,
        completedCompanyInfo: false,
        uploadedCompanyDetails: false,
        addedCompanyOwners: false,
        kycamlChecked: false,
        documentNeeded: true,
        accountVerified: false,
        showkeybtn: false,
        ownerkycamlChecked: false,
    })
    const mainMenu = useRef()

    const mobileSmall = useMediaQuery('(max-width:700px)')

    useEffect(async () => {
        let match,
            pl = /\+/g,
            search = /([^&=]+)=?([^&]*)/g,
            decode = function (s) {
                return decodeURIComponent(s.replace(pl, ' '))
            },
            query = window.location.search.substring(1)
        let urlParams = {}
        while ((match = search.exec(query))) urlParams[decode(match[1])] = decode(match[2])
        if (urlParams.search) {
            setSearchText(urlParams.search)
            if (location.pathname == '/search') {
                setInitLoad(true)
            }
        }
    }, [])
    useEffect(() => {
        if (initLoad) {
            setTimeout(function () {
                handleSearchButtonClick()
            }, 2000)
            setInitLoad(false)
        }
    }, [initLoad])

    useEffect(() => {
        if (isAuthenticated) {
            getLinkedCreditCard()
            getExternalAccount()
        }
    }, [isAuthenticated])

    const handleSearchBox = () => {
        setSearchBox(!searchBox)
    }

    const handleEmailVerify = () => {
        sendEmailVerifyLink({ email: user.email })
    }

    const handleVerify = () => {
        setVerify(true)
    }

    const enableOneof = false

    useEffect(() => {
        if (isAuthenticated) {
            getAllCartProducts(search)

            if (enableOneof) {
                getOffers({
                    email: user?.email ? user?.email : '',
                })
            }

            // if (history.location.search.includes('welcome=1')) {
            //     setWelcomePopup(true)
            // }
        }
    }, [isAuthenticated, user])

    useEffect(() => {
        if (isAuthenticated) {
            console.log('user?.purchase_blocked', user?.purchase_blocked, window.location.pathname)
            if (user && user?.purchase_blocked) {
                if (window.location.pathname !== '/account/profile') {
                    console.log('user?.purchase_blocked true')
                    setRestrictPopup(true)
                }
            }
        }
    }, [isAuthenticated, user])

    useEffect(() => {
        if (user && user?.id) {
            const givenDateStr = user.created_at
            const givenDate = new Date(givenDateStr)
            const currentDate = new Date()

            // Convert both dates to UTC for an accurate comparison
            const givenTime = Date.UTC(
                givenDate.getUTCFullYear(),
                givenDate.getUTCMonth(),
                givenDate.getUTCDate(),
            )
            const currentTime = Date.UTC(
                currentDate.getUTCFullYear(),
                currentDate.getUTCMonth(),
                currentDate.getUTCDate(),
            )

            // Calculate difference in days
            const diffInDays = (currentTime - givenTime) / (1000 * 60 * 60 * 24)

            if (diffInDays >= 1) {
                setShowRecord(true)
            } else {
                setShowRecord(false)
            }
        }
    }, [user])

    const markAccuntStatus = (ty) => {
        let accountStatusObj = circle
        accountStatusObj.kycamlChecked = false
        accountStatusObj.addedCompanyOwners = false

        if (ty == 'owner' || user?.user_type === 0) {
            accountStatusObj.addedCompanyOwners = true
            accountStatusObj.ownerkycamlChecked = true
        }

        if (ty == 'kyc') {
            accountStatusObj.kycamlChecked = true
        }

        if (ty == 'payment') {
            accountStatusObj.setupPaymentMethod = true
        }

        if (user && northCapitalUser) {
            accountStatusObj.emailVerified = user && !user.mail_verified ? false : true
            accountStatusObj.documentNeeded =
                user.domesticYN === 'international_account' ||
                //user.regType === 'company' ||
                user.user_type === 1
                    ? true
                    : false
            accountStatusObj.showkeybtn =
                user && (user.company_owner_updated || user.profile_updated) ? true : false

            const individualInternationalUser =
                userType == 0 && user.domesticYN == 'international_account' ? true : false

            /*             if (
                (northCapitalUser?.amlstatus === 'Approved' ||
                    northCapitalUser?.amlstatus === 'Auto Approved' ||
                    northCapitalUser?.amlstatus === 'Manually Approved') &&
                (northCapitalUser?.kycstatus === 'Approved' ||
                    northCapitalUser?.kycstatus === 'Auto Approved' ||
                    northCapitalUser?.kycstatus === 'Manually Approved')
            ) {
                accountStatusObj.kycamlChecked = true
                //accountStatusObj.showkeybtn = false
            } */

            if (
                ((userType === 1 || (userType === 0 && individualInternationalUser)) &&
                    (northCapitalUser?.amlstatus === 'Approved' ||
                        northCapitalUser?.amlstatus === 'Auto Approved' ||
                        northCapitalUser?.amlstatus === 'Manually Approved')) ||
                (userType === 0 &&
                    !individualInternationalUser &&
                    (northCapitalUser?.amlstatus === 'Approved' ||
                        northCapitalUser?.amlstatus === 'Auto Approved' ||
                        northCapitalUser?.amlstatus === 'Manually Approved') &&
                    (northCapitalUser?.kycstatus === 'Approved' ||
                        northCapitalUser?.kycstatus === 'Auto Approved' ||
                        northCapitalUser?.kycstatus === 'Manually Approved'))
            ) {
                accountStatusObj.kycamlChecked = true
                //accountStatusObj.showkeybtn = false
            }

            if (
                accountStatusObj.kycamlChecked ||
                (user.domesticYN === 'international_account' &&
                    user.mail_verified === 1 &&
                    northCapitalUser.isDocumentUploaded === 1) ||
                (user.domesticYN === 'domestic_account' &&
                    user.user_type === 0 &&
                    user.mail_verified === 1) ||
                (user.user_type === 1 && northCapitalUser.isDocumentUploaded === 1)
            ) {
                accountStatusObj.accountVerified = true
                accountStatusObj.uploadedCompanyDetails = true
            } else {
                accountStatusObj.accountVerified = false

                if (user && user.user_type === 1) {
                    if (northCapitalUser.isDocumentUploaded === 0) {
                        accountStatusObj.uploadedCompanyDetails = false
                    } else {
                        accountStatusObj.uploadedCompanyDetails = true
                    }
                } else if (
                    user &&
                    user.domicile == 'non-resident' &&
                    northCapitalUser.isDocumentUploaded === 0
                ) {
                    accountStatusObj.uploadedCompanyDetails = false
                    setDocumentUploaded(false)
                    setShowNonResident(true)
                } else {
                    accountStatusObj.uploadedCompanyDetails = false
                    if (
                        user &&
                        user.domesticYN !== 'domestic_account' &&
                        user.domicile == 'non-resident' &&
                        northCapitalUser.isDocumentUploaded === 1
                    ) {
                        setDocumentUploaded(true)
                        setShowNonResident(false)
                    }
                }
            }

            if (!user.socialsecurity && user.domicile != 'non-resident') {
                accountStatusObj.completedCompanyInfo = false
            } else {
                if (user.domicile) {
                    accountStatusObj.completedCompanyInfo = true
                } else {
                    accountStatusObj.completedCompanyInfo = false
                }
            }

            if (user.kyc_admin_review === 1 && user.kyc_check_failed >= 2) {
                setKycAdminReview(true)
            }

            if (
                user?.user_type === 1 /* &&
                (northCapitalUser?.amlstatus === 'Approved' ||
                    northCapitalUser?.amlstatus === 'Auto Approved' ||
                    northCapitalUser?.amlstatus === 'Manually Approved') */
            ) {
                let companyOwnerVerified = true
                if (
                    company_owner_data &&
                    company_owner_data.record &&
                    company_owner_data.record.length > 0
                ) {
                    company_owner_data.record.map((item, index) => {
                        if (companyOwnerVerified && !item.verified) {
                            companyOwnerVerified = false
                        }
                        if (
                            !kycAdminReview &&
                            item.kyc_review === 1 &&
                            item.kyc_check_failed >= 2
                        ) {
                            setKycAdminReview(true)
                        }
                    })

                    accountStatusObj.addedCompanyOwners = true
                }

                //console.log(companyOwnerVerified)
                if (companyOwnerVerified) {
                    //console.log('ss')
                    //accountStatusObj.kycamlChecked = true
                    accountStatusObj.ownerkycamlChecked = true
                    accountStatusObj.showkeybtn = false
                } else {
                    //accountStatusObj.kycamlChecked = false
                    accountStatusObj.ownerkycamlChecked = false
                    /* accountStatusObj.showkeybtn = true */
                }
            }

            /* if (
                user.kyc_check_failed > 0 &&
                user.kyc_check_failed % 2 == 0 &&
                northCapitalUser.isDocumentUploaded === 0
            ) {
                setUploadDocument(true)
            } */
        }

        const scrollToTop =
            accountStatusObj?.emailVerified &&
            accountStatusObj?.setupPaymentMethod &&
            accountStatusObj?.completedCompanyInfo &&
            accountStatusObj?.uploadedCompanyDetails &&
            accountStatusObj?.addedCompanyOwners
                ? true
                : false

        if (scrollToTop) {
            window.scrollTo(0, 200)
        }

        if (
            scrollToTop &&
            accountStatusObj?.kycamlChecked &&
            accountStatusObj?.ownerkycamlChecked
        ) {
            setUserVerify(1)
            accountStatusObj.showkeybtn = false
        } else {
            setUserVerify(0)
        }

        console.log(accountStatusObj, '++++')

        if (accountStatusObj?.kycamlChecked) {
            setKycProcessed(true)
        } else {
            setKycProcessed(false)
        }

        setCircle(accountStatusObj)
        setVerify(false)
    }

    useEffect(() => {
        if (user && Object.keys(user).length) {
            if (user.user_type === 1) {
                getCompanyOwners({})
            }
            console.log('changed one')
        }
    }, [northCapitalUser, user])

    useEffect(() => {
        setVerify(true)
        if (card || bank) {
            console.log('going on this')
            markAccuntStatus('payment')
        } else {
            markAccuntStatus('')
        }
    }, [card, bank])

    useEffect(() => {
        if (
            north_capital_bank_details &&
            north_capital_bank_details.data &&
            north_capital_bank_details.data.statusDesc &&
            north_capital_bank_details.data.statusDesc.AccountNumber
        ) {
            setBank(true)
        }
        if (
            north_capital_card_details &&
            north_capital_card_details.data &&
            north_capital_card_details.data.creditcardDetails &&
            north_capital_card_details.data.creditcardDetails.creditCardNumber
        ) {
            setCard(true)
        }
    }, [north_capital_bank_details, north_capital_card_details])

    useEffect(() => {
        // console.log(search_allproducts.cartrecords)
        setCartProducts(
            search_allproducts.cartrecords.length && search_allproducts.cartrecords[0].cartItems
                ? search_allproducts.cartrecords[0].cartItems
                : [],
        )
    }, [search_allproducts])

    useEffect(() => {
        setCartProducts([])
        return () => {
            setCartProducts([])
        }
    }, [])

    const onLogOut = () => {
        logout()
        localStorage.removeItem('popup')
        setCount({
            auctionCount: 0,
            buynowCount: 0,
        })
        localStorage.removeItem('temp_user_id')
        localStorage.removeItem('ttw_temp_user_id')
        localStorage.removeItem('bidIncrease')
        setAlert('Logged out successfully', 'success')
        handleRedirectInternal(history, '')
        setanchormenu(null)
        setanchorcart(null)
        setSearchText('')
        clearOffers()
    }

    const toggleDrawer = (anchor, open) => (event) => {
        setState({ ...state, [anchor]: open })
    }

    const handleCart = (event) => {
        setanchorcart(event.currentTarget)
    }
    const handleMenu = (event) => {
        setanchormenu(event.currentTarget)
    }

    const handleClose = (history, path) => {
        setanchormenu(null)
        setanchorcart(null)
        if (history && path && path !== 'backdropClick') {
            handleRedirectInternal(history, path)
        }
    }

    const listHandle = (value) => {
        let search = {
            filters: {
                auctiontype: {
                    value:
                        value == 'all_closed' || value == 'all'
                            ? ''
                            : value === 'all_ttw_closed'
                            ? 'ttw'
                            : value,
                    type: 'in',
                    field: 'p.auctiontype',
                },
            },
            market_status: ['open'],
            from: 'search',
        }
        if (value === 'all_closed') {
            search.market_status = ['closed', 'sold']
        } else if (value === 'all_ttw_closed') {
            search.market_status = ['sold']
        }

        return search
    }

    const getSearchBarObjet = (value) => {
        if (searchValue) {
            return {
                ...searchValue,
                filters: {
                    ...searchValue.filters,
                    searchbar: {
                        ...searchValue.filters.searchbar,
                        value: value,
                    },
                },
            }
        } else {
            return {
                limit: 12,
                page: 1,
                orderby: 'p.id, desc',
                order: '',
                filters: {
                    searchbar: {
                        value: value,
                        type: 'like',
                        field: 'p.title,p.desc_proc',
                    },
                },
            }
        }
    }

    const handleSearchTextChange = (e) => {
        setSearchText(e.target.value)
    }

    const handleSearchButtonClick = async () => {
        setSearchBox(!searchBox)
        if (typeof searchText != 'undefined') {
            await setSearchValue(getSearchBarObjet(searchText))
            setState({ ...state, top: false })
            if (location.pathname != '/search') {
                handleRedirectInternal(history, 'search')
            }
            let match,
                pl = /\+/g,
                search = /([^&=]+)=?([^&]*)/g,
                decode = function (s) {
                    return decodeURIComponent(s.replace(pl, ' '))
                },
                query = window.location.search.substring(1)
            let urlParams = {}
            while ((match = search.exec(query))) urlParams[decode(match[1])] = decode(match[2])
            urlParams.search = searchText
            let queryparam = Object.entries(urlParams)
                .map(([key, val]) => `${key}=${val}`)
                .join('&')
            history.replace({
                search: queryparam,
            })
        } else {
            // setSearch({
            //     ...search,
            //     filters: {
            //         ...search.filters,
            //         searchbar: {
            //             ...search.filters.searchbar,
            //             value: searchValue.filters.searchbar.value,
            //         },
            //     },
            // })
        }
    }

    const handleSearchKeyDown = async (e) => {
        if (e.key === 'Enter') {
            await setSearchValue(getSearchBarObjet(searchText))
            if (location.pathname != '/search') {
                handleRedirectInternal(history, 'search')
            }
            let match,
                pl = /\+/g,
                search = /([^&=]+)=?([^&]*)/g,
                decode = function (s) {
                    return decodeURIComponent(s.replace(pl, ' '))
                },
                query = window.location.search.substring(1)
            let urlParams = {}
            while ((match = search.exec(query))) urlParams[decode(match[1])] = decode(match[2])
            urlParams.search = searchText
            let queryparam = Object.entries(urlParams)
                .map(([key, val]) => `${key}=${val}`)
                .join('&')
            history.replace({
                search: queryparam,
            })
        }
    }

    useEffect(() => {
        if (searchValue && searchValue.filters && searchValue.filters.searchbar) {
            setSearchText(searchValue.filters.searchbar.value)
        }
        // if (searchValue && searchValue.market_status) {
        //     setMenu('past_auction')
        // } else {
        //     setMenu('auction')
        // }
    }, [searchValue])

    useEffect(() => {
        if (isAuthenticated) {
            let auctionFilter = {
                table: 'buynow',
                field: 'id',
                extraField: '',
                filters: {
                    buynow_autype: {
                        value: 'live',
                        type: 'in',
                        field: 'b.buynow_autype',
                    },
                    paid: {
                        value: '0',
                        type: 'in',
                        field: 'b.paid',
                    },
                    partial: {
                        value: '0',
                        type: 'in',
                        field: 'b.partial',
                    },
                },
            }
            let buyNowFilter = {
                table: 'cart_temp',
                field: 'cart_id',
                extraField: '',
                filters: {
                    paid: {
                        value: '0',
                        type: 'in',
                        field: 'crt.paid',
                    },
                },
            }

            loadPendingCount(buyNowFilter, 'buynowCount')

            loadPendingCount(auctionFilter, 'auctionCount')

            if (user.email && window._learnq && window._learnq._loaded) {
                var _learnq = window._learnq || []
                console.log([
                    _learnq,
                    'identify',
                    {
                        $email: user.email,
                    },
                ])
                _learnq.push([
                    'identify',
                    {
                        $email: user.email,
                    },
                ])
            }
        } else {
            let buyNowFilter = {
                table: 'cart_temp_wl',
                field: 'cart_id',
                extraField: '',
                temp_user_id: localStorage?.temp_user_id ? localStorage?.temp_user_id : 0,
                filters: {
                    paid: {
                        value: '0',
                        type: 'in',
                        field: 'crt.paid',
                    },
                },
            }
            if (localStorage?.temp_user_id) {
                loadPendingTempCount(buyNowFilter, 'buynowCount')
            }
        }
    }, [isAuthenticated, history.location.pathname])

    const newRegistration = true

    useEffect(() => {
        if (isAuthenticated) {
            if (northCapitalUser) {
                // if (!northCapitalUser.suitability) {
                //     handleRedirectInternal(history, 'suitability')
                // } else if (!northCapitalUser.kyc_review) {
                //     if (history.location.pathname === '/suitability') {
                //         handleRedirectInternal(history, 'search')
                //     }
                //     if (
                //         northCapitalUser.kycstatus !== 'Approved' &&
                //         northCapitalUser.kycstatus !== 'Auto Approved'
                //     ) {
                //         toggleFullScreenKYCPopup(true, 'new')
                //     }
                // }
                if (user.reg_step_count < 3 && !user.reg_steps_skip.includes('3')) {
                    if (newRegistration) {
                        if (user.skipReg && user.skipReg > 0) {
                            handleRedirectInternal(
                                history,
                                user.skipReg === 1 || user.skipReg == '1'
                                    ? 'account/profile'
                                    : 'search',
                            )
                        }
                    } else {
                        handleRedirectInternal(history, 'registration/Addpayment')
                    }

                    return false
                }
                if (!northCapitalUser.kyc_review) {
                    if (history.location.pathname === '/registration/uploadDocument/1') {
                        handleRedirectInternal(history, 'search')
                    }
                    if (!newRegistration) {
                        // we no longer need this.
                        if (user.is_document_later === 0) {
                            if (user.user_type === 0 && user.domesticYN === 'domestic_account') {
                            } else {
                                handleRedirectInternal(history, 'registration/uploadDocument/1')
                            }
                        }
                    }
                    /*if (
                        northCapitalUser.kycstatus !== 'Approved' &&
                        northCapitalUser.kycstatus !== 'Auto Approved'
                    ) {
                        if (
                            user.kyc_request_count !== 2 &&
                            user.domesticYN === 'domestic_account'
                        ) {
                            handleRedirectInternal(history, 'registration/reupdate')
                        } else {
                            if (user.is_document_later === 0) {
                                handleRedirectInternal(history, 'registration/uploadDocument/1')
                            }
                        }
                    }*/
                }
            }
        }
    }, [isAuthenticated, northCapitalUser, history.location.pathname])

    const [count, setCount] = useState({
        auctionCount: 0,
        buynowCount: 0,
    })

    useEffect(() => {
        if (cartCount?.auctionCount) {
            setCount({ ...count, auctionCount: cartCount.auctionCount.totalRecords })
        }
        if (cartCount?.buynowCount) {
            setCount({ ...count, buynowCount: cartCount.buynowCount.totalRecords })
        }
    }, [cartCount])

    useEffect(() => {
        if (cartTempCount?.buynowCount && !isAuthenticated && localStorage.temp_user_id) {
            setCount({ ...count, buynowCount: cartTempCount.buynowCount.totalRecords })
            if (cartTempCount.buynowCount.totalRecords) {
                localStorage.setItem('cartTempCount', cartTempCount.buynowCount.totalRecords)
            } else {
                localStorage.removeItem('cartTempCount')
            }
        } else {
            setCount({
                auctionCount: 0,
                buynowCount: 0,
            })
            localStorage.removeItem('cartTempCount')
        }
    }, [cartTempCount])

    const handleMenuToggle = (activeMenu) => {
        setAucOpen((prevOpen) => !prevOpen)
        setMenu(activeMenu)
    }

    const handleMenuClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return
        }
        setAucOpen(false)
    }

    const setValue = (value) => {
        if (location.pathname !== '/search') {
            handleRedirectInternal(history, 'search')
        }
        {
            window.location.pathname == '/search'
                ? (getAllSearchProducts(listHandle(value)),
                  setAucOpen(false),
                  setSearchValue(listHandle(value)))
                : null
        }
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault()
            setAucOpen(false)
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(aucopen)
    React.useEffect(() => {
        if (prevOpen.current === true && aucopen === false) {
            anchorRef.current.focus()
        }

        prevOpen.current = aucopen
    }, [aucopen])

    const [manageKYC, setManageKYC] = useState({
        popup: false,
        status: 'new',
        data: null,
    })

    const toggleFullScreenKYCPopup = (popup, status, data) => {
        setManageKYC({ popup, status, data })
    }

    useEffect(() => {
        if (isAuthenticated && freeOffers.length && enableOneof) {
            if (!localStorage.getItem('confirmPopup')) {
                if (!localStorage.getItem('popup')) {
                    setFreePopup(true)
                    setFreeData(freeOffers)
                    localStorage.setItem('popup', true)
                }
            }
        }
    }, [freeOffers, isAuthenticated])

    const handlePopupClose = () => {
        updateProfile(
            {
                purchase_blocked: 0,
            },
            true,
        )

        setRestrictPopup(false)
        handleRedirectInternal(history, 'account/profile')
    }

    /* useEffect(() => {
        if (history.location.search.includes('welcome=1')) {
            setWelcomePopup(true)
        }
    }, []) */

    const mobile = useMediaQuery('(max-width:1200px)')

    const headerRef = useRef(null)
    const [bannerTop, setBannerTop] = useState(70) // Default position

    useEffect(() => {
        const updateBannerPosition = () => {
            if (headerRef.current) {
                const headerBottom = headerRef.current.getBoundingClientRect().bottom
                setBannerTop(Math.max(0, headerBottom)) // Ensure it never goes below 0px
            }
        }

        window.addEventListener('scroll', updateBannerPosition)
        window.addEventListener('resize', updateBannerPosition)

        updateBannerPosition() // Initial call

        return () => {
            window.removeEventListener('scroll', updateBannerPosition)
            window.removeEventListener('resize', updateBannerPosition)
        }
    }, [])

    console.log('rendering header', verify)

    return (
        <div className={`${!isAuthenticated ? 'customClassMobile' : ''}`}>
            {!mobile ? (
                <>
                    <Loaders name="home" isLoading={isLoading} />

                    <header
                        className={
                            'mainHeader d-flex align-items-center justify-content-between px-10'
                        }
                        ref={headerRef}
                    >
                        {(!isAuthenticated || mobile) && (
                            <div className="srchlogoContainer">
                                <a href="https://songvest.com" id="songvest_logo">
                                    <img src={LOGO_WHITE} className="mnLogo cursorDecoy" />
                                </a>
                            </div>
                        )}
                        <div className="navsContainer d-flex align-items-center justify-content-end">
                            <Link className="mnNvlLnks" to="/" id="liveinvestments_link">
                                Explore Offerings
                            </Link>
                            <a
                                className="mnNvlLnks"
                                href="https://www.songvest.com/how-it-works"
                                id="faninvestorbenefits_link"
                            >
                                How it Works
                            </a>
                            <a
                                className="mnNvlLnks"
                                href="https://www.songvest.com/sellroyalties"
                                id="sellingroyalties_link"
                            >
                                Selling Royalties
                            </a>
                            <a
                                className="mnNvlLnks"
                                href="https://www.songvest.com/about-us"
                                id="aboutus_link"
                            >
                                About
                            </a>
                        </div>
                        <div className="profileContainer">
                            <div className={`srchContainer d-flex align-items-center`}>
                                <div className="imageContainer">
                                    <img src="/assets/svg/search_icon.svg" />
                                </div>
                                <input
                                    id="homepage_search_inputfield"
                                    placeholder="Search"
                                    onClick={handleSearchBox}
                                    type="search"
                                    value={searchText}
                                    onChange={handleSearchTextChange}
                                    onKeyDown={handleSearchKeyDown}
                                />
                            </div>
                            {!isAuthenticated ? (
                                <>
                                    <IconButton
                                        className="cartBtn mx-3"
                                        onClick={() => handleClose(history, 'buynowcart')}
                                        id="homepage_cart"
                                    >
                                        <Badge
                                            badgeContent={count.buynowCount || 0}
                                            color="primary"
                                        >
                                            <img src="/assets/svg/shopping-cart.svg" />
                                        </Badge>
                                    </IconButton>
                                    <div className="bfrLgnCont">
                                        <span className="material-icons ml-3 mr-2">
                                            account_circle
                                        </span>
                                        <Link to="/login" id="login_link">
                                            Login
                                        </Link>
                                        <span className="mx-2">/</span>
                                        <Link to="/register" id="register_link">
                                            Register
                                        </Link>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <IconButton
                                        className="cartBtn"
                                        onClick={() => handleClose(history, 'buynowcart')}
                                        id="homepage_cart"
                                    >
                                        <Badge
                                            badgeContent={count.buynowCount || 0}
                                            color="primary"
                                        >
                                            <img src="/assets/svg/shopping-cart.svg" />
                                        </Badge>
                                    </IconButton>
                                    <div
                                        role="button"
                                        ref={mainMenu}
                                        className="acntBtnDrop cursorPointer"
                                        aria-controls="simple-menu"
                                        aria-haspopup="true"
                                        onClick={handleMenu}
                                        id="homepage_profile"
                                    >
                                        <div className="profilePicContainer">
                                            {false ? (
                                                <img className="profilePic" src=""></img>
                                            ) : (
                                                <img
                                                    className="profilePicPlaceholder"
                                                    src="/assets/svg/user_icon.svg"
                                                ></img>
                                            )}
                                        </div>

                                        <span className="userInfo">
                                            {`Hi ${
                                                user?.user_type === 0
                                                    ? capitalizeFirstLetter(user.first_name)
                                                    : capitalizeFirstLetter(user.companyname)
                                            }`}
                                        </span>
                                        <span className="material-icons profileMenu">
                                            expand_more
                                        </span>
                                    </div>
                                    <Popover
                                        id="simple-menu"
                                        anchorEl={mainMenu.current}
                                        keepMounted
                                        className={`headerDropMenu ${
                                            document.body.dir === 'rtl' && 'rtl'
                                        }`}
                                        onClose={handleClose}
                                        open={Boolean(anchormenu)}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                    >
                                        <MenuList
                                            autoFocusItem={open}
                                            id="menu-list-grow"
                                            onKeyDown={handleListKeyDown}
                                        >
                                            {/* <MenuItem
                                                onClick={() => handleClose(history, 'buynowcart')}
                                            >
                                                <img
                                                    src="/assets/svg/myauctions.svg"
                                                    className="mr-2"
                                                />
                                                Cart
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() => handleClose(history, 'auctions/all')}
                                            >
                                                <img
                                                    src="/assets/svg/mysongshares.svg"
                                                    className="mr-2"
                                                />
                                                My SongShares
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() =>
                                                    handleClose(history, 'account/profile')
                                                }
                                            >
                                                <span className="material-icons mr-2">person</span>
                                                Profile
                                            </MenuItem> */}
                                            <MenuItem onClick={() => onLogOut()}>
                                                <span className="material-icons mr-2">
                                                    power_settings_new
                                                </span>
                                                Logout
                                            </MenuItem>
                                        </MenuList>
                                    </Popover>
                                </>
                            )}
                        </div>
                    </header>
                </>
            ) : (
                <header className="mainHeader customContainer pt-3 pb-3" ref={headerRef}>
                    {(!isAuthenticated || mobile) && (
                        <div className="srchlogoContainer">
                            {/* <img src="/assets/svg/whitevector.svg" className="logoBack" /> */}
                            <a href="https://songvest.com" id="songvest_logo">
                                <img src={LOGO_WHITE} className="mnLogo cursorDecoy" />
                            </a>
                        </div>
                    )}
                    <div className="navsContainer d-flex align-items-center justify-content-end">
                        {!mobileSmall ? (
                            <div className={`srchContainer d-flex align-items-center mr-3`}>
                                <img className="srchIcon" src="/assets/svg/search.svg" />
                                <input
                                    placeholder="Search"
                                    onClick={handleSearchBox}
                                    type="search"
                                    value={searchText}
                                    onChange={handleSearchTextChange}
                                    onKeyDown={handleSearchKeyDown}
                                />
                            </div>
                        ) : (
                            <IconButton
                                className="mobMenuBtn mr-2"
                                onClick={toggleDrawer('top', true)}
                            >
                                <img className="mobsrchIcon" src="/assets/svg/search.svg" />
                            </IconButton>
                        )}
                        {isAuthenticated && (
                            <IconButton
                                className="cartBtn mr-2"
                                onClick={() => handleClose(history, 'buynowcart')}
                            >
                                <Badge badgeContent={count.buynowCount || 0} color="primary">
                                    <img src="/assets/svg/shopping-cart.svg" />
                                </Badge>
                            </IconButton>
                        )}

                        <IconButton className="mobMenuBtn" onClick={toggleDrawer('left', true)}>
                            <span className="material-icons">menu</span>
                        </IconButton>
                        <SwipeableDrawer
                            anchor={'left'}
                            open={state['left']}
                            onClose={toggleDrawer('left', false)}
                            onOpen={toggleDrawer('left', true)}
                        >
                            <SideNavBar navbarClick={toggleDrawer('left', false)} />
                        </SwipeableDrawer>
                        <SwipeableDrawer
                            className="mblSrchDrawer"
                            anchor={'top'}
                            open={state['top']}
                            onClose={toggleDrawer('top', false)}
                            onOpen={toggleDrawer('top', true)}
                        >
                            <div className={`mblSrchContainer d-flex align-items-center`}>
                                <input
                                    placeholder="Search"
                                    onClick={handleSearchBox}
                                    type="search"
                                    value={searchText}
                                    onChange={handleSearchTextChange}
                                    onKeyDown={handleSearchKeyDown}
                                />
                                <Button
                                    className="btn srchBtn verifyButton"
                                    onClick={handleSearchButtonClick}
                                >
                                    <img className="srchIcon" src="/assets/svg/search.svg" />
                                </Button>
                            </div>
                        </SwipeableDrawer>
                    </div>
                </header>
            )}
            <div
                // style={{
                //     position: 'fixed',
                //     top: `60px`,
                //     width: mobile ? '100%' : '100%',
                //     // transition: "top 0.3s ease-in-out",
                // }}
                className="verifyBannerParent"
            >
                {!dismissVerifyStartBanner &&
                ((!verify &&
                    user?.user_type == 0 &&
                    !northCapitalUser?.isDocumentUploaded &&
                    (northCapitalUser?.kycstatus == 'Disapproved' ||
                        !northCapitalUser?.kycstatus)) ||
                    (user?.user_type == 1 &&
                        !northCapitalUser?.isDocumentUploaded &&
                        (northCapitalUser?.amlstatus == 'Disapproved' ||
                            !northCapitalUser?.amlstatus))) ? (
                    <div
                        className="verifyBanner"
                        // style={{
                        //     position: 'fixed',
                        //     top: `${bannerTop}px`,
                        //     width: mobile ? '100%' : 'calc(100% - 222px)',
                        //     // transition: "top 0.3s ease-in-out",
                        // }}
                    >
                        <div className="verifyBannerText">
                            {'You`re almost there! Verify your account now to get started'}
                        </div>
                        <div className="d-flex align-items-center">
                            <Button
                                className="btn srchBtn verifyButton"
                                onClick={() => handleRedirectInternal(history, 'verify')}
                            >
                                Finish Now
                            </Button>
                            <Button
                                id="dialog_closeBtn"
                                className="closeBtn"
                                onClick={() => {
                                    handleVerify()
                                    setDismissVerifyStartBanner(true)
                                }}
                            >
                                <span className="material-icons">close</span>
                            </Button>
                        </div>
                    </div>
                ) : null}

                {northCapitalUser &&
                !verify &&
                ((user?.user_type == 1 && northCapitalUser?.amlstatus === 'Approved') ||
                    (user?.user_type == 1 &&
                        northCapitalUser?.amlstatus === 'Auto Approved' &&
                        northCapitalUser?.isDocumentUploaded) ||
                    (northCapitalUser?.kyc_review && northCapitalUser?.isDocumentUploaded) ||
                    (user?.user_type == 1 && northCapitalUser?.amlstatus === 'Manually Approved') ||
                    (user?.user_type == 0 && northCapitalUser?.kycstatus === 'Approved') ||
                    (user?.user_type == 0 &&
                        northCapitalUser?.kycstatus === 'Auto Approved' &&
                        northCapitalUser?.isDocumentUploaded) ||
                    (user?.user_type == 0 &&
                        northCapitalUser?.kycstatus === 'Auto Approved' &&
                        northCapitalUser?.amlstatus === 'Auto Approved') ||
                    (user?.user_type == 0 && northCapitalUser?.kycstatus === 'Manually Approved') ||
                    (user?.user_type == 0 &&
                        !northCapitalUser.kycStatus &&
                        northCapitalUser?.isDocumentUploaded &&
                        northCapitalUser?.amlstatus === 'Auto Approved')) &&
                !user?.mail_verified &&
                !circle?.setupPaymentMethod &&
                isAuthenticated ? (
                    <div
                        className="verifyBanner"
                        // style={{
                        //     position: 'fixed',
                        //     top: `${bannerTop}px`,
                        //     width: mobile ? '100%' : 'calc(100% - 222px)',
                        //     // transition: "top 0.3s ease-in-out",
                        // }}
                    >
                        <div className="verifyBannerText">
                            {'Nearly there! Complete the last steps to start buying SongShares'}
                        </div>
                        <Button
                            className="btn srchBtn verifyButton"
                            onClick={async () => {
                                if (location.pathname !== '/account/profile') {
                                    await handleRedirectInternal(
                                        history,
                                        'account/profile/#complete',
                                    )
                                }
                                const element = document.getElementById('complete')
                                if (element) {
                                    element.scrollIntoView({ behavior: 'smooth' })
                                }
                            }}
                        >
                            Complete
                        </Button>
                        <Button
                            id="dialog_closeBtn"
                            className="closeBtn"
                            onClick={() => handleVerify()}
                        >
                            <span className="material-icons">close</span>
                        </Button>
                    </div>
                ) : null}
                {northCapitalUser &&
                !verify &&
                ((user?.user_type == 1 && northCapitalUser?.amlstatus === 'Approved') ||
                    (user?.user_type == 1 &&
                        northCapitalUser?.amlstatus === 'Auto Approved' &&
                        northCapitalUser?.isDocumentUploaded) ||
                    (northCapitalUser?.kyc_review && northCapitalUser?.isDocumentUploaded) ||
                    (user?.user_type == 1 && northCapitalUser?.amlstatus === 'Manually Approved') ||
                    (user?.user_type == 0 && northCapitalUser?.kycstatus === 'Approved') ||
                    (user?.user_type == 0 &&
                        northCapitalUser?.kycstatus === 'Auto Approved' &&
                        northCapitalUser?.isDocumentUploaded) ||
                    (user?.user_type == 0 &&
                        northCapitalUser?.kycstatus === 'Auto Approved' &&
                        northCapitalUser?.amlstatus === 'Auto Approved') ||
                    (user?.user_type == 0 && northCapitalUser?.kycstatus === 'Manually Approved') ||
                    (user?.user_type == 0 &&
                        !northCapitalUser.kycstatus &&
                        northCapitalUser?.isDocumentUploaded &&
                        northCapitalUser?.amlstatus === 'Auto Approved')) &&
                !user?.mail_verified &&
                circle?.setupPaymentMethod &&
                isAuthenticated &&
                !verify ? (
                    <div
                        className="verifyBanner"
                        // style={{
                        //     position: 'fixed',
                        //     top: `${bannerTop}px`,
                        //     width: mobile ? '100%' : 'calc(100% - 222px)',
                        //     // transition: "top 0.3s ease-in-out",
                        // }}
                    >
                        <div className="verifyBannerText">
                            {
                                'You`re so close! Verify your email address to finish setting up your account setup and start buying SongShares'
                            }
                        </div>
                        <Button
                            className="btn srchBtn verifyButton"
                            onClick={() => handleEmailVerify()}
                        >
                            Resend Email Verification
                        </Button>
                        <Button
                            id="dialog_closeBtn"
                            className="closeBtn"
                            onClick={() => handleVerify()}
                        >
                            <span className="material-icons">close</span>
                        </Button>
                    </div>
                ) : null}

                {northCapitalUser &&
                !verify &&
                ((user?.user_type == 1 && northCapitalUser?.amlstatus === 'Approved') ||
                    (user?.user_type == 1 &&
                        northCapitalUser?.amlstatus === 'Auto Approved' &&
                        northCapitalUser?.isDocumentUploaded) ||
                    (northCapitalUser?.kyc_review && northCapitalUser?.isDocumentUploaded) ||
                    (user?.user_type == 1 && northCapitalUser?.amlstatus === 'Manually Approved') ||
                    (user?.user_type == 0 && northCapitalUser?.kycstatus === 'Approved') ||
                    (user?.user_type == 0 &&
                        northCapitalUser?.kycstatus === 'Auto Approved' &&
                        northCapitalUser?.isDocumentUploaded) ||
                    (user?.user_type == 0 &&
                        northCapitalUser?.kycstatus === 'Auto Approved' &&
                        northCapitalUser?.amlstatus === 'Auto Approved') ||
                    (user?.user_type == 0 && northCapitalUser?.kycstatus === 'Manually Approved') ||
                    (user?.user_type == 0 &&
                        !northCapitalUser.kycstatus &&
                        northCapitalUser?.isDocumentUploaded &&
                        northCapitalUser?.amlstatus === 'Auto Approved')) &&
                !circle?.setupPaymentMethod &&
                user?.mail_verified &&
                isAuthenticated &&
                !verify ? (
                    <div
                        className="verifyBanner"
                        // style={{
                        //     position: 'fixed',
                        //     top: `${bannerTop}px`,
                        //     width: mobile ? '100%' : 'calc(100% - 222px)',
                        //     // transition: "top 0.3s ease-in-out",
                        // }}
                    >
                        <div className="verifyBannerText">
                            {
                                'You`re so close! Add a payment method to finish setting up your account setup and start buying SongShares'
                            }
                        </div>
                        <Button
                            className="btn srchBtn verifyButton"
                            onClick={() => handleRedirectInternal(history, 'paymentinfo')}
                        >
                            Add Payment Method
                        </Button>
                        <Button
                            id="dialog_closeBtn"
                            className="closeBtn"
                            onClick={() => handleVerify()}
                        >
                            <span className="material-icons">close</span>
                        </Button>
                    </div>
                ) : null}

                {northCapitalUser &&
                ((user?.user_type == 1 && northCapitalUser?.amlstatus === 'Approved') ||
                    (user?.user_type == 1 &&
                        northCapitalUser?.amlstatus === 'Auto Approved' &&
                        northCapitalUser?.isDocumentUploaded) ||
                    (northCapitalUser?.kyc_review && northCapitalUser?.isDocumentUploaded) ||
                    (user?.user_type == 1 && northCapitalUser?.amlstatus === 'Manually Approved') ||
                    (user?.user_type == 0 && northCapitalUser?.kycstatus === 'Approved') ||
                    (user?.user_type == 0 &&
                        northCapitalUser?.kycstatus === 'Auto Approved' &&
                        northCapitalUser?.isDocumentUploaded) ||
                    (user?.user_type == 0 &&
                        northCapitalUser?.kycstatus === 'Auto Approved' &&
                        northCapitalUser?.amlstatus === 'Auto Approved') ||
                    (user?.user_type == 0 && northCapitalUser?.kycstatus === 'Manually Approved') ||
                    (user?.user_type == 0 &&
                        !northCapitalUser.kycStatus &&
                        northCapitalUser?.isDocumentUploaded &&
                        northCapitalUser?.amlstatus === 'Auto Approved')) &&
                isAuthenticated &&
                !accountPopup &&
                !user?.kyc_aml_ribbon_status ? (
                    <div
                        className="verifyBanner"
                        // style={{
                        //     position: 'fixed',
                        //     top: `${bannerTop}px`,
                        //     width: mobile ? '100%' : 'calc(100% - 222px)',
                        //     // transition: "top 0.3s ease-in-out",
                        // }}
                    >
                        <div className="verifyBannerText">
                            {kycAdminReview
                                ? 'Your Account Verification Is In Review'
                                : 'Your Account Has Been Approved'}
                        </div>
                        <Button
                            id="dialog_closeBtn"
                            className="closeBtn"
                            onClick={() => {
                                updateProfile(
                                    {
                                        kyc_aml_ribbon_status: 1,
                                    },
                                    true,
                                )
                                setAccountPopup(true)
                            }}
                        >
                            <span className="material-icons">close</span>
                        </Button>
                    </div>
                ) : null}
                {circle?.kycamlChecked &&
                circle?.ownerkycamlChecked &&
                circle?.setupPaymentMethod &&
                circle?.emailVerified &&
                isAuthenticated &&
                !user.record_label_shown &&
                !hideRecord &&
                showRecord ? (
                    <div
                        className="verifyBanner"
                        // style={{
                        //     position: 'fixed',
                        //     top: `${bannerTop}px`,
                        //     width: mobile ? '100%' : 'calc(100% - 222px)',
                        //     // transition: "top 0.3s ease-in-out",
                        // }}
                    >
                        <div className="verifyBannerText">
                            {'Did you know you can create your own public record label ?'}
                        </div>
                        <Button
                            className="btn srchBtn verifyButton recordButton"
                            onClick={async () => {
                                if (location.pathname !== '/account/profile') {
                                    await handleRedirectInternal(
                                        history,
                                        'account/profile/#recordLabelForm',
                                    )
                                }

                                const element = document.getElementById('recordLabelForm')
                                if (element) {
                                    element.scrollIntoView({ behavior: 'smooth' })
                                }
                            }}
                        >
                            Click Here to Learn How
                        </Button>
                        <Button
                            id="dialog_closeBtn"
                            className="closeBtn"
                            onClick={() => updateProfile({ record_label_shown: 1 }, true)}
                        >
                            <span className="material-icons">close</span>
                        </Button>
                    </div>
                ) : null}
            </div>
            <KYCUpdate data={manageKYC} function={toggleFullScreenKYCPopup} />
            <CustomDialog
                className="alert"
                title="Note"
                open={toggleDialogCanada}
                function={() => setToggleDialogCanada(false)}
            >
                <div className="bidCnfModalCnt">
                    <h5>{`Canadian users cannot ${canadaUserErrorMessage} at this time.`}</h5>
                </div>

                <div className="actionWrapper mt-1">
                    <PrimaryButton onClick={() => setToggleDialogCanada(false)}>
                        Close
                    </PrimaryButton>
                </div>
            </CustomDialog>
            {/* <FreeShares
                open={freePopup}
                openFunction={() => setFreePopup(false)}
                data={freeData}
                user={user}
            /> */}
            <FormDialog
                className="freeSharePopup wlcmPopup"
                open={restrictPopup}
                handleClose={() => handlePopupClose()}
                maxWidth={'sm'}
            >
                <div className="wlcmCntnr">
                    <img src={LOGO} />
                    <h2>Please update your address and contact info.</h2>
                    <p>
                        To purchase shares you have to pass the SEC &quot;Know Your Customer&quot;
                        (KYC) and &quot;Anti Money Laundering&quot; (AML) test by having the correct
                        address information entered in the system. Go to your settings page to
                        confirm it has been completed and your auto purchase will complete.{' '}
                    </p>
                    <Button className="btn srchBtn verifyButton" onClick={handlePopupClose}>
                        Continue
                    </Button>

                    {/* <p>Thank you for registering an account with us!</p> */}
                </div>
            </FormDialog>
            <FormDialog
                className="freeSharePopup wlcmPopup"
                open={welcomePopup}
                handleClose={() => setWelcomePopup(false)}
                maxWidth={'sm'}
            >
                <div className="wlcmCntnr">
                    <img src={LOGO} />
                    <h2>Welcome To SongVest!</h2>
                    <p>Thank you for registering an account with us!</p>
                    <p>
                        You&apos;re now on your way to taking part in the success and journey of
                        some of your favorite artists.
                    </p>
                    <p>
                        We&apos;re glad to have you here and we look forward to providing you with
                        exciting offerings that you can be a part of!
                    </p>
                </div>
            </FormDialog>
            <BidHistory />
            <TTWBidHistory />
        </div>
    )
}
export default Header
